import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import { RequireVendor } from './components/RequireVendor';
import Dashboard from './pages/Dashboard';
import Assets from './pages/Assets';
import AssetEditor from './pages/AssetEditor';
import Sales from './pages/Sales';
import Payouts from './pages/Payouts';
import Messages from './pages/Messages';
import Login from './pages/Login';

function App() {
  return (
    <div className="app">
      <Header />
      <main>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <RequireVendor>
                <Dashboard />
              </RequireVendor>
            }
          />
          <Route
            path="/assets"
            element={
              <RequireVendor>
                <Assets />
              </RequireVendor>
            }
          />
          <Route
            path="/assets/new"
            element={
              <RequireVendor>
                <AssetEditor />
              </RequireVendor>
            }
          />
          <Route
            path="/assets/:id"
            element={
              <RequireVendor>
                <AssetEditor />
              </RequireVendor>
            }
          />
          <Route
            path="/sales"
            element={
              <RequireVendor>
                <Sales />
              </RequireVendor>
            }
          />
          <Route
            path="/payouts"
            element={
              <RequireVendor>
                <Payouts />
              </RequireVendor>
            }
          />
          <Route
            path="/messages"
            element={
              <RequireVendor>
                <Messages />
              </RequireVendor>
            }
          />
        </Routes>
      </main>
      <footer className="footer">
        <p>Ludic Drive Assetstore — Vendor Frontend</p>
      </footer>
    </div>
  );
}

export default App;
